import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { isCustomerAllowedPath } from '../../utils/customerAccess';

interface CustomerRouteGuardProps {
  children: React.ReactNode;
}

const CustomerRouteGuard: React.FC<CustomerRouteGuardProps> = ({ children }) => {
  const { loading, isCustomerPortalUser } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '50vh' }}>
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  if (isCustomerPortalUser() && !isCustomerAllowedPath(location.pathname)) {
    return <Navigate to="/access-denied" state={{ from: location }} replace />;
  }

  return <>{children}</>;
};

export default CustomerRouteGuard;
